module.exports = __webpack_public_path__ + "assets/img/account-bind.37c51fc.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/account-bind.png
// module id = 5u7H
// module chunks = 50